import * as signalR from "@microsoft/signalr";
import toastr from "toastr";

class Notifications {
    constructor() {
        this.connection = new signalR.HubConnectionBuilder()
            .withUrl("/notifications")
            .build();
        
        let app = this;

        app.connection.on("ReceiveEntityUpdatedNotification", (entityName, entityId) => {
            app.ReceiveEntityUpdatedNotification(entityName, entityId);
        });

        app.connection.on("ReceiveMessage", (message, type) => {
            app.ReceiveMessage(message, type);
        });

        app.connection.start().catch(err => console.error(err.toString()));
        
        $('#send').on('click', function () {
            //app.connection.invoke("SendMessage", "Test Message", "info").catch(err => console.error(err.toString()));
            
            //ajax download
            $.ajax({
                type: "GET",
                url: "/Download",
                success: function (data) {
                    console.log(data);
                }
            });
            
        });
    }
    
    ReceiveEntityUpdatedNotification(entityName, entityId) {
        return this.ReceiveMessage(`${entityName} with Id: ${entityId} has been updated.`, "info");
    }
    
    ReceiveMessage(message, type) {
        console.log(`Received message: ${message}`);
        switch (type) {
            case "SuccessMessage":
                toastr.success(message);
                break;
            case "ErrorMessage":
                toastr.error(message);
                break;
            case "InfoMessage":
                toastr.info(message);
                break;
            case "WarningMessage":
                toastr.warning(message);
                break;
            case "StickySuccessMessage":
                toastr.success(message, null, {
                    closeButton: true,
                    timeOut: 0,
                    extendedTimeOut: 0
                });
                break;
        }
    }
}

export default Notifications;
